import { ExpressPaymentMethodStatus } from '../../models/expressCheckout';
import { CheckoutState } from '../../state';
import { PaypalScriptStatus } from '../../state/paypal';
import {
    areExpressCheckoutConditionsLoaded,
    isPaypalAvailableAsExpressPaymentMethod,
} from '../expressCheckoutConditions';
import { getPaypalScriptStatus } from './pureSelectors';

const paypalScriptStatusConsideredFullyLoaded = new Set([
    PaypalScriptStatus.failed,
    PaypalScriptStatus.loaded,
]);

export const getPayPalExpressPaymentMethodStatus = (state: CheckoutState) => {
    if (!areExpressCheckoutConditionsLoaded(state)) {
        return ExpressPaymentMethodStatus.availabilityNotEvaluatedYet;
    }

    if (!isPaypalAvailableAsExpressPaymentMethod(state)) {
        return ExpressPaymentMethodStatus.unavailable;
    }

    return paypalScriptStatusConsideredFullyLoaded.has(
        getPaypalScriptStatus(state),
    )
        ? ExpressPaymentMethodStatus.fullyLoaded
        : ExpressPaymentMethodStatus.loadingScripts;
};
